import React, { useContext, useState } from 'react';

// Images
import Freetakistan from '../../assets/images/Freetakistan.png';
import M240 from '../../assets/images/m240.jpg';

// Components
import Header from '../../components/Header/index';

// Material-ui
import { Typography, Button } from '@material-ui/core';

// Context
import AuthContext from '../../Context/context';

const NotAuthenticated = () => {
    const { emailVerified } = useContext(AuthContext);

    return (
        <div>
            <Header />

            <div className="email-verification">
                <div className='text-center'>
                    <img src={Freetakistan} alt='Freetakistan Logo' style={{ width: '150px' }} />
                </div>

                <br />
                <i><p style={{ textAlign: 'center', fontWeight: 'bold', color: 'red' }}>Você não esta autenticado! =(</p></i>
                <hr />
                {
                    !emailVerified &&
                    <div>
                        <div className='text-center'>
                            <img src={M240} alt='Parceria FreeTakistan' style={{ width: '300px', borderRadius: '15px', marginBottom: '1.5em', marginTop: '1em' }} />
                        </div>

                        <Typography component="h4" variant="h4" color="inherit" style={{ textAlign: 'center', marginBottom: '1em' }}>
                            Você precisa estar <strong>logado</strong> e com seu <strong>email verificado</strong> para entrar nesta página!
                        </Typography>

                        <div style={{ marginTop: '1.5em', marginBottom: '1.5em', textAlign: 'center' }}>
                            <Button variant='contained' id="btn-padrao" href='/login'>Login</Button><Button variant="contained" id="btn-padrao" href='/cadastro' style={{ marginLeft: '40px' }}>Cadastrar</Button>
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default NotAuthenticated;